export default "__VITE_ASSET__zLS$Pmzn__"